import Vue from 'vue';
import VueRouter from 'vue-router';
import { isLoggedIn } from '../services/users';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: () => import('../views/LayoutNotLoggedIn.vue'),
    children: [
      {
        path: '/',
        name: 'landing',
        component: () => import('../views/Landing.vue'),
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/ContactUs.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue'),
      },
      {
        path: '/code',
        name: 'job-code',
        component: () => import('../views/JobCode.vue'),
      },
      {
        path: '/checkout/success',
        name: 'payments-success',
        component: () => import('../views/PaymentSuccess.vue'),
      },
      {
        path: '/checkout/cancelled',
        name: 'payments-cancelled',
        component: () => import('../views/PaymentCancelled.vue'),
      },
      {
        path: '/checkout/:hash',
        name: 'payments.get',
        component: () => import('../views/JobPayment.vue'),
      },
      {
        path: '/enter-password/:token',
        name: 'enter-password',
        component: () => import('../views/EnterPassword.vue'),
      },
      {
        path: '/password-reset/success',
        name: 'pasword-reset-success',
        component: () => import('../views/PasswordResetSuccess.vue'),
      },
      {
        path: '/sign-up-form',
        name: 'sign-up-form',
        component: () => import('../views/SignUpForm.vue'),
      },
      {
        path: '/sign-up-form-success',
        name: 'sign-up-form-success',
        component: () => import('../views/SignUpFormSuccess.vue'),
      },
      {
        path: '/password-reset-email',
        name: 'password-reset-email',
        component: () => import('../views/PasswordResetEmail.vue'),
      },
      {
        path: '/password-reset',
        name: 'password-reset',
        component: () => import('../views/PasswordReset.vue'),
      },
    ],
  },
  {
    path: '',
    component: () => import('../views/LayoutAdmin.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/users',
        name: 'users',
        component: () => import('../views/UserTable.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/users/create',
        name: 'users-create',
        props: {
          mode: 'CREATE',
        },
        component: () => import('../views/UserForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/users/edit/:userId',
        name: 'users-edit',
        props: {
          mode: 'EDIT',
        },
        component: () => import('../views/UserForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/companies',
        name: 'companies',
        component: () => import('../views/CompanyTable.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/companies/create',
        name: 'companies-create',
        props: {
          mode: 'CREATE',
        },
        component: () => import('../views/CompanyForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/companies/edit/:companyId',
        name: 'companies-edit',
        props: {
          mode: 'EDIT',
        },
        component: () => import('../views/CompanyForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs',
        name: 'jobs',
        component: () => import('../views/JobTable.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/request-company',
        name: 'request-company',
        component: () => import('../views/RequestCompany.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/create',
        name: 'jobs-create',
        props: {
          mode: 'CREATE',
        },
        component: () => import('../views/JobForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/create-admin',
        name: 'jobs-create-admin',
        props: {
          mode: 'CREATE',
        },
        component: () => import('../views/JobFormAdmin.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/:jobId',
        name: 'job-details',
        component: () => import('../views/JobDetails.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/edit/:jobId',
        name: 'jobs-edit',
        props: {
          mode: 'EDIT',
        },
        component: () => import('../views/JobForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs-admin/edit/:jobId',
        name: 'jobs-admin-edit',
        props: {
          mode: 'EDIT',
        },
        component: () => import('../views/JobFormAdmin.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/markets',
        name: 'markets.get',
        component: () => import('../views/MarketTable.vue'),
      },
      {
        path: '/unions',
        name: 'unions',
        component: () => import('../views/UnionTable.vue'),
      },
      {
        path: '/unions/create',
        name: 'unions-create',
        props: {
          mode: 'CREATE',
        },
        component: () => import('../views/UnionForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/unions/edit/:unionId',
        name: 'union-edit',
        props: {
          mode: 'EDIT',
        },
        component: () => import('../views/UnionForm.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/payroll-providers',
        name: 'payroll-providers',
        component: () => import('../views/PayrollProviderTable.vue'),
        meta: { mustBeLoggedIn: true },
      },
      {
        path: '/jobs/request-company-success',
        name: 'request-company-success',
        component: () => import('../views/RequestCompanySuccess.vue'),
        meta: { mustBeLoggedIn: true },
      },
    ],
  },
  {
    path: '',
    component: () => import('../views/LayoutNotLoggedInSubmission.vue'),
    children: [
      {
        path: '/caps/:hash',
        name: 'caps',
        component: () => import('../views/JobSubmission.vue'),
      },
      {
        path: '/job/:hash',
        name: 'job',
        component: () => import('../views/JobSubmission.vue'),
      },
      {
        path: '/submissions/:hash',
        name: 'submission',
        component: () => import('../views/JobSubmission.vue'),
      },
      {
        path: '/submissions/revolution/:hash',
        name: 'submission-revolution',
        component: () => import('../views/JobSubmissionRevolution.vue'),
      },
      {
        path: '/submissions/art/revolution/:hash',
        name: 'submission-art-revolution',
        props: {
          artLink: true,
        },
        component: () => import('../views/JobSubmissionRevolution.vue'),
      },
      {
        path: '/submissions/canada/:hash',
        name: 'submission-canada',
        component: () => import('../views/JobSubmissionCanada.vue'),
      },
      {
        path: '/submissions/art/canada/:hash',
        name: 'submission-art-canada',
        props: {
          artLink: true,
        },
        component: () => import('../views/JobSubmissionCanada.vue'),
      },
      {
        path: '/submissions/dot/:hash',
        name: 'submission-dot',
        component: () => import('../views/JobSubmissionDot.vue'),
      },
      {
        path: '/submissions/invoice/:hash',
        name: 'submission-invoice',
        component: () => import('../views/JobSubmissionInvoice.vue'),
      },
      {
        path: '/submissions/art/:hash',
        name: 'submission-art',
        props: {
          artLink: true,
        },
        component: () => import('../views/JobSubmission.vue'),
      },
      {
        path: '/submissions/StartingPaperwork/:hash',
        name: 'submission-invoice',
        component: () => import('../views/JobSubmissionStartingPaperwork.vue'),
      },
      {
        path: '/submissions/art/StartingPaperwork/:hash',
        name: 'submission-art',
        props: {
          artLink: true,
        },
        component: () => import('../views/JobSubmissionStartingPaperwork.vue'),
      },
      {
        path: '/submissions/art/:hash',
        name: 'submission-art',
        props: {
          artLink: true,
        },
        component: () => import('../views/JobSubmissionStartingPaperwork.vue'),
      },
      {
        path: '/formComplete',
        name: 'formComplete',
        component: () => import('../views/FormComplete.vue'),
      },
      {
        path: '/referralSuccess',
        name: 'referral-success',
        component: () => import('../views/ReferralSuccess.vue'),
      },
    ],
  },
  {
    path: '*',
    component: () => import('../views/LayoutNotLoggedIn.vue'),
    children: [{
      path: '',
      name: '404',
      component: () => import('../views/404.vue'),
    }],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.mustBeLoggedIn) {
    const { data } = await isLoggedIn();
    if (!data) {
      next({ name: 'login', query: { redirect: to.path } });
      return;
    }
  }
  next();
});

export default router;
